var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.item.Property && _vm.item.Property.length > 0)?_c('div',_vm._l((_vm.item.Property),function(item){return _c('property',{key:item.Name,attrs:{"name":"item","property":item}})}),1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }